import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { LoginService } from '../security/login.service';

@Component({
  selector: 'app-booking-report-preview',
  templateUrl: './booking-report-preview.component.html',
  styleUrls: ['./booking-report-preview.component.css']
})
export class BookingReportPreviewComponent implements OnInit {

  htmlString!: SafeResourceUrl;
  cssString: string = "{'background-color': 'red'}";
  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private loginService: LoginService,
    private domSanitizer: DomSanitizer
  ) { 
    this.loginService.activatedNavigationComponent = false;
  }

  ngOnInit(): void {
    let reportId = Number(this.route.snapshot.paramMap.get("reportId"));
    this.httpService.getBookingReportPreview(reportId).subscribe(res => {
      this.htmlString = this.domSanitizer.bypassSecurityTrustHtml(res);;
    });
  }
}
